export default "__VITE_ASSET__DXKwz$pf__"